import { useCallback, useRef, useState } from "react";

import { useDebugTrigger } from "./triggers/use-debug-trigger";
import { useMouseTopTrigger } from "./triggers/use-mouse-top-trigger";
import { useTimerTrigger } from "./triggers/use-timer-trigger";

type Options = {
  delayMs: number;
  thresholdPx: number;
};

export function usePromotionOpen({ delayMs, thresholdPx }: Options) {
  const [isOpen, setIsOpen] = useState(false);
  const hasTriggeredRef = useRef(false);

  const enabled = !isOpen && !hasTriggeredRef.current;

  const open = useCallback(() => {
    hasTriggeredRef.current = true;
    setIsOpen(true);
  }, []);

  useTimerTrigger(open, { delayMs, enabled });
  useMouseTopTrigger(open, { thresholdPx, enabled });
  useDebugTrigger(open);

  return { isOpen, setIsOpen };
}
